import React from 'react';
import classNames from 'classnames';
import FontAwesomeIcon from 'src/components/Icon';
import Button from 'src/components/Button';
import { onUrlImageExtensionExist } from 'src/helpers/CommonHelpers';
import { Attachments } from 'src/pages/ServiceRequests/components/Attachments';
import './AttachmentPreview.scss';

interface PreviewMediaProps {
  isImage: boolean;
  isPdf: boolean;
  source: string | undefined;
  fileName: string;
}

const PreviewMedia = ({
  isImage,
  isPdf,
  source,
  fileName,
}: PreviewMediaProps) => {
  if (isImage) {
    return (
      <Attachments
        attachments={{
          hasAttachment: true,
          firstCompressedAttachment: source,
          totalAttachments: 1,
        }}
        onClickAttachment={() => {}}
        fromMessages
        fileName={fileName}
        wide
      />
    );
  }

  if (isPdf) {
    return (
      <Attachments
        attachments={{ hasAttachment: true, totalAttachments: 1 }}
        onClickAttachment={() => {}}
        fromMessages
        isPdf
        fileName={fileName}
        wide
      />
    );
  }

  return <span className="attachment-name">{fileName}</span>;
};

export interface AttachmentPreviewProps {
  attachment: any;
  onDelete?: () => void;
  annotated?: boolean;
}

const AttachmentPreview = ({
  attachment,
  onDelete,
  annotated,
}: AttachmentPreviewProps) => {
  const fileName: string = attachment.name ?? attachment.path ?? 'attachment';
  const source: string | undefined = attachment.preview ?? attachment.url;

  const isImage: boolean =
    attachment.type?.startsWith('image/') ||
    onUrlImageExtensionExist(source ?? fileName);

  const isPdf: boolean =
    attachment.type === 'application/pdf' ||
    fileName.toLowerCase().endsWith('.pdf');

  const showAnnotationStatus: boolean = annotated !== undefined && isImage;

  return (
    <div className="attachment-preview">
      <PreviewMedia
        isImage={isImage}
        isPdf={isPdf}
        source={source}
        fileName={fileName}
      />

      {showAnnotationStatus && (
        <span
          className={classNames('annotation-status', {
            'is-annotated': annotated,
          })}
        >
          {annotated ? 'Annotated' : 'Not annotated'}
        </span>
      )}

      {onDelete && (
        <div className="delete-button">
          <Button
            color="semantic"
            label={<FontAwesomeIcon glyph="trash" weight="light" />}
            onClick={onDelete}
          />
        </div>
      )}
    </div>
  );
};

export default AttachmentPreview;
